export const sources={};export const img={src:"__VITE_ASSET__JoDxeQ1xEKeZpTWUJ7TFQw__",w:640,h:640};export default{sources:sources,img:img};